import { extendTheme } from 'native-base';
import { colorsDark, colorsLight } from './colors';
import { fontSizes, lineHeights, letterSpacings } from './fonts';

export const THEME_LIGHT_COLOR = extendTheme({
  colors: colorsLight,
  fontSizes,
  lineHeights,
  letterSpacings,
});

export const THEME_DARK_COLOR = extendTheme({
  colors: colorsDark,
  fontSizes,
  lineHeights,
  letterSpacings,
});

// 2. Get the type of the CustomTheme
type CustomThemeType = typeof THEME_LIGHT_COLOR;

// 3. Extend the internal NativeBase Theme
declare module 'native-base' {
  interface ICustomTheme extends CustomThemeType {}
}